module.exports = __webpack_public_path__ + "static/media/surveyWhiteLogo.45c04508.png";